import { createNamespacedHelpers } from "vuex";
import config from "@Web3WalletConfig/config.json";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "mFooter",
  computed: {
    ...walletVuex.mapState(["isMobile"]),
    twitterUrl() {
      return config.twitterUrl;
    }
  }
};